import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vfmPlugin from 'vue-final-modal'
import Popper from 'vue3-popper'
import VueLazyload from 'vue-lazyload';
import Toaster from '@meforma/vue-toaster';
import 'devextreme/dist/css/dx.light.css';

createApp(App)
.use(store)
.use(vfmPlugin)
.use(VueLazyload)
.use(Popper)
.use(Toaster)
.use(router)
.mount('#app')
